/**
 * TanStack Query hooks for `predictive-anomaly-detection`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	predictiveAnomalyDetectionQueryKeys,
	type CreatePredictiveAnomalyDetectionBody,
	type ListPredictiveAnomalyDetectionResponse,
	type PredictiveAnomalyDetectionRow,
} from "./api";

export function usePredictiveAnomalyDetectionList(): UseQueryResult<ListPredictiveAnomalyDetectionResponse, Error> {
	return useQuery({
		queryKey: predictiveAnomalyDetectionQueryKeys.list(),
		queryFn: list,
	});
}

export function usePredictiveAnomalyDetectionCreate(): UseMutationResult<PredictiveAnomalyDetectionRow, Error, CreatePredictiveAnomalyDetectionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: predictiveAnomalyDetectionQueryKeys.all });
		},
	});
}

export function usePredictiveAnomalyDetectionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: predictiveAnomalyDetectionQueryKeys.all });
		},
	});
}
